import { render } from "./iMenu.vue?vue&type=template&id=73106d0f&scoped=true"
import script from "./iMenu.vue?vue&type=script&lang=js"
export * from "./iMenu.vue?vue&type=script&lang=js"

import "./iMenu.vue?vue&type=style&index=0&id=73106d0f&lang=less&scoped=true"

import exportComponent from "G:\\project\\csadmin-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73106d0f"]])

export default __exports__